import React from "react"
import {FacetLabel} from "../../../components"
import FacetListButtonText from "../../../facetListButtonText"
import {Filter} from "../../../../../../models/Filter"

interface StandardFacetLabelProps {
    $isOnSecondRow: boolean
    filter: Filter
}

export const StandardFacetLabel = ({$isOnSecondRow, filter}: StandardFacetLabelProps) => {
    return (
        <FacetLabel>
            <FacetListButtonText $isOnSecondRow={$isOnSecondRow}>{filter.displayName}</FacetListButtonText>
        </FacetLabel>
    )
}

export default StandardFacetLabel
